import 'core-js/features/promise';

import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './components/App';
import '@amzn/awsui-global-styles/polaris.css';
import { NavProvider } from './components/navigation/context';
import { AuthProvider } from './authentication/context';
import { PermissionsProvider } from './ConferencePages/conferenceInfo/ui/permissionscontext';
import { loadConfig } from './config';

document.addEventListener('DOMContentLoaded', () => {
  void (async () => {
    try {
      await loadConfig();
    } catch (err) {
      console.error('Failed to load app config:', err);
      // Fall through — getApiInvokeUrl() will use fallback
    }

    const container = document.querySelector('#app');
    const root = createRoot(container!);
    root.render(
      <HashRouter>
        <NavProvider>
          <PermissionsProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </PermissionsProvider>
        </NavProvider>
      </HashRouter>
    );
  })();
});
